<template>
    <transition-page
        :title="trans('streams.stream_complete.title')"
        :description="trans('streams.stream_complete.description')"
        imgPath="/images/end-of-master-illustration.svg"
        :ctaText="trans('streams.stream_complete.cta')"
        chapterName=""
        chapterIcon=""
        @onCompleted="onCompleted"
    />
</template>
<script>
import TransitionPage from "../../molecules/TransitionPage"

export default {
    name: "StreamCompleted",
    components: {TransitionPage},
    data: () => ({
        missionId: null,
    }),
    mounted() {
        this.missionId = this.$route.params.id
        this.getMissionData()
    },
    methods: {
        onCompleted() {
            this.$router.push({name: 'streamCertificate', id: this.$route.params.id})
        }
    },
}
</script>
